import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Search, Globe, Sparkles } from 'lucide-react';
import header from '../assets/header.jpg';

function Navbar({ currentLang, onLangChange, searchQuery, onSearchChange }) {
  const navigate = useNavigate();
  const location = useLocation();

  const text = {
    en: { booking: "Booking", material: "Learning Material", search: "Search file titles or topics...", delivery: "Digital Delivery Worldwide" },
    gr: { booking: "Κρατήσεις", material: "Εκπαιδευτικό Υλικό", search: "Αναζήτηση τίτλων ή θεμάτων...", delivery: "Ψηφιακή Παράδοση Παγκοσμίως" },
    it: { booking: "Prenotazioni", material: "Materiale Didattico", search: "Cerca titoli o argomenti...", delivery: "Consegna Digitale Globale" }
  };

  const handleSearchInputChange = (e) => {
    const value = e.target.value;
    onSearchChange(value);

    if (value && location.pathname !== '/material') {
      navigate('/material');
    }
  };

  return (
    <div className="w-100 d-flex flex-column" style={{ zIndex: 10 }}>
      <div className="top-utility-bar">
        <div className="container d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center gap-2">
            <Sparkles size={12} className="text-warning" />
            <span>{text[currentLang].delivery}</span>
          </div>
          <div className="d-flex align-items-center gap-4">
            <div className="d-flex align-items-center gap-1">
              <Globe size={12} className="text-muted" />
              <select className="lang-selector" value={currentLang} onChange={(e) => onLangChange(e.target.value)}>
                <option value="en">English (EN)</option>
                <option value="gr">Ελληνικά (GR)</option>
                <option value="it">Italiano (IT)</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <nav className="navbar navbar-expand-md navbar-light" style={{ position: 'relative', backgroundImage: `url(${header})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(255, 255, 255, 0.95)', zIndex: 0 }}></div>

        <div className="container py-3" style={{ position: 'relative', zIndex: 1 }}>
          <Link className="navbar-brand fs-2 mb-0" to="/"><b>Pterόessa</b></Link>

          <div className="search-container d-none d-md-block mx-4">
            <input 
              type="text" 
              className="search-input" 
              placeholder={text[currentLang].search} 
              value={searchQuery}
              onChange={handleSearchInputChange}
            />
            <Search size={18} className="text-muted" style={{ position: 'absolute', right: '14px', top: '11px' }} />
          </div>

          <button className="navbar-toggler border-0" type="button" data-bs-toggle="collapse" data-bs-target="#collapsibleNavbar">
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse justify-content-end" id="collapsibleNavbar">
            <ul className="navbar-nav gap-2 align-items-center">
              <li className="nav-item">
                <Link className="nav-link text-uppercase small font-weight-bold" to="/booking">{text[currentLang].booking}</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link text-uppercase small font-weight-bold" to="/material">{text[currentLang].material}</Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default Navbar;